<template>
  <el-scrollbar>
    <div class="app">
      <h4>员工信息：</h4>
      <el-form label-width="140px" class="bordered-container">
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名：">
              <el-input v-model="employeeRegular.employeeName" style="width: 100%" disabled/>
            </el-form-item>
            <el-form-item label="职位：">
              <el-select v-model="employeeRegular.positionId" style="width: 100%" disabled>
                <el-option v-for="item in positionList" :key="item.id" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工号：">
              <el-input v-model="employeeRegular.employeeNo" style="width: 100%" disabled/>
            </el-form-item>
            <el-form-item label="部门：">
              <el-cascader style="width: 100%"
                           v-model="employeeRegular.departmentId"
                           :show-all-levels="false"
                           :options="departmentList"
                           disabled
                           :props="CascaderProp" ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入职日期：">
              <el-input v-model="employeeRegular.entryDate" style="width: 100%" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计划转正日期：">
              <el-input v-model="employeeRegular.probationEndDate" style="width: 100%" disabled/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <h4>转正办理：</h4>
      <el-col class="bordered-container">
        <el-form label-width="140px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="转正日期：" required>
                <el-date-picker v-model="regularDate" placeholder="选择日期" style="width: 100%"
                                type="month" value-format="YYYY-MM" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注：">
                <el-input v-model="remark" style="width: 100%" :autosize="{ minRows: 5, maxRows: 8 }" type="textarea"/>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="附件：">
                <el-row>
                  <!--                  <el-text style="color:#409efe;margin-bottom: 10px">共 {{ fileList.length }} 份</el-text>-->
                  <kf-file-upload v-model="file_id"
                                  @fileChange="fileChange"
                                  :limit="1" :showTotalCnt="true" :showSuccessCnt="true"></kf-file-upload>
                  <!--                  <el-upload class="upload-button"-->
                  <!--                             action="http://localhost:8888/upload"-->
                  <!--                             :on-success="handleUploadSuccess"-->
                  <!--                             :on-error="handleUploadError"-->
                  <!--                             :before-upload="beforeUpload"-->
                  <!--                             v-model:file-list="fileList"-->
                  <!--                             :limit="5"-->
                  <!--                             accept=".pdf"-->
                  <!--                             multiple>-->
                  <!--                    <el-button type="text" icon="el-icon-upload" style="margin-left: 45px">-->
                  <!--                      <i class="el-icon-folder-add"></i> 上传文件-->
                  <!--                    </el-button>-->
                  <!--                  </el-upload>-->
                </el-row>
              </el-form-item>

              <el-row v-for="(file, index) in fileList" :key="file.uid" style="margin-left: 140px;">
                <el-col :span="12">
                  <span>{{ index + 1 }}. </span>
                  <el-button type="text" @click="previewFile(file)">{{ file.name }}</el-button>
                </el-col>
                <el-col :span="12" class="file-actions">
                  <el-button type="text" @click="startPage(file)">
                    <i class="el-icon-view"></i> 预览
                  </el-button>
                  <el-button type="text" @click="downloadPage(file)">
                    <i class="el-icon-download"></i> 下载
                  </el-button>
                  <el-button type="text" style="color: red;" @click="deleteFile(file)">
                    <i class="el-icon-delete"></i> 删除
                  </el-button>
                </el-col>
              </el-row>
            </el-col>
            <!--            <el-button text @click="downloadPage(item)" style="color: #033B64;">下载</el-button>-->

            <!--            <el-col :span="22" v-for="item in fileDataList" :key="item.id">-->
            <!--              <el-button text @click="startPage(item,fileDataList)">{{ item.original_name }}</el-button>-->
            <!--              <el-form-item>-->

            <!--              </el-form-item>-->

            <!--            </el-col>-->

          </el-row>
        </el-form>
      </el-col>
      <h4>转正薪资与职位变动：</h4>
      <el-row class="bordered-container">
        <el-col :span="12">
          <el-form label-width="140px" disabled>
            <h4 style="margin:0 0 15px 140px">转正前：</h4>
            <el-form-item label="职位：">
              <el-select v-model="employeeRegular.positionId" style="width: 100%" disabled>
                <el-option v-for="item in positionList" :key="item.id" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="基本薪资：">
              <el-input-number :min="0" v-model="beforeRegular.salary_basic" step="1000" :precision="2"
                               placeholder="基本薪资" style="width: 100%" clearable/>
            </el-form-item>
            <el-form-item label="绩效工资：">
              <el-input-number :min="0" v-model="beforeRegular.salary_merit" step="1000" :precision="2"
                               placeholder="绩效工资" style="width: 100%" clearable/>
            </el-form-item>
            <el-form-item label="岗位津贴：">
              <el-input-number :min="0" v-model="beforeRegular.salary_job_allowance" :precision="2" step="1000"
                               placeholder="岗位津贴" style="width: 100%" clearable/>
            </el-form-item>
            <el-form-item label="奖金：">
              <el-input-number :min="0" v-model="beforeRegular.salary_award" :precision="2" step="1000"
                               placeholder="奖金" style="width: 100%" clearable/>
            </el-form-item>
            <el-form-item label="餐补：">
              <el-input-number :min="0" v-model="beforeRegular.salary_meal" :precision="2" step="100"
                               placeholder="餐补" style="width: 100%" clearable/>
            </el-form-item>
            <el-form-item label="话费补贴：">
              <el-input-number :min="0" v-model="beforeRegular.salary_phone" :precision="2" step="100"
                               placeholder="话费补贴" style="width: 100%" clearable/>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <h4 style="margin:0 0 15px 140px">转正后：</h4>
          <el-form label-width="140px">
            <el-form-item label="职位：">
              <el-select v-model="afterRegular.after_position_id" style="width: 100%">
                <el-option v-for="item in positionList" :key="item.id" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="基本薪资：">
              <el-input-number :min="0" v-model="afterRegular.after_salary_basic" step="1000" :precision="2"
                               placeholder="基本薪资" style="width: 100%" clearable/>
            </el-form-item>
            <el-form-item label="绩效工资：">
              <el-input-number :min="0" v-model="afterRegular.after_salary_merit" step="1000" :precision="2"
                               placeholder="绩效工资" style="width: 100%" clearable/>
            </el-form-item>
            <el-form-item label="岗位津贴：">
              <el-input-number :min="0" v-model="afterRegular.after_salary_job_allowance" :precision="2" step="1000"
                               placeholder="岗位津贴" style="width: 100%" clearable/>
            </el-form-item>
            <el-form-item label="奖金：">
              <el-input-number :min="0" v-model="afterRegular.after_salary_award" :precision="2" step="1000"
                               placeholder="奖金" style="width: 100%" clearable/>
            </el-form-item>
            <el-form-item label="餐补：">
              <el-input-number :min="0" v-model="afterRegular.after_salary_meal" :precision="2" step="100"
                               placeholder="餐补" style="width: 100%" clearable/>
            </el-form-item>
            <el-form-item label="话费补贴：">
              <el-input-number :min="0" v-model="afterRegular.after_salary_phone" :precision="2" step="100"
                               placeholder="话费补贴" style="width: 100%" clearable/>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div style="text-align: center">
        <el-button type="primary" @click="saveButton">保存</el-button>
      </div>

    </div>
  </el-scrollbar>
</template>

<script>

// import PrcPdf from "@/views/applications/prc/PrcPdf.vue";

export default {
  name: "EmployeeRegularProcessApply",
  // components: {PrcPdf},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      employeeRegular: {
        employeeName: '',
        employeeNo: '',
        positionId: '',
        departmentId: '',
        employeeType: '',
        entryDate: '',
        probationEndDate: '',
      },
      beforeRegular: {
        salary_basic: '',
        salary_phone: '',
        salary_meal: '',
        salary_award: '',
        salary_job_allowance: '',
        salary_merit: ''
      },
      afterRegular: {
        after_salary_basic: '',
        after_salary_phone: '',
        after_salary_meal: '',
        after_salary_award: '',
        after_salary_job_allowance: '',
        after_salary_merit: ''
      },
      remark: '',
      regularDate: '',
      fileData: {},
      fileDataList: [],
      positionList: [],
      empTypeList: [],
      fileList: [],
      salaryTypeList: [],
      departmentList: [],
      file_id: [],
      CascaderProp: {
        emitPath:false,
        checkStrictly:true,
        multiple: true,
        value: 'id',
        label: 'name'
      },
    }
  },

  methods: {
    async fileChange(ids) {
      console.log(ids)
      if (ids.length <= 0) {
        this.file_id = ''
        return
      }
      this.file_id = ids;
    },
    checkMoney(value) {
      if (value == null || Number(value) <= 0 || value === ''){
        return true
      }
      return false
    },
    async saveButton() {
      if (this.regularDate == null) {
        this.$message.error("请选择转正日期");
        return;
      }
      if (this.afterRegular.after_position_id == null){
        this.$message.error("请选择转正后职位");
        return;
      }
      if (this.checkMoney(this.afterRegular.after_salary_basic)) {
        this.$message.error("请填写正确的薪资");
        return;
      }
      if (this.checkMoney(this.afterRegular.after_salary_merit)) {
        this.$message.error("请填写正确的绩效工资");
        return;
      }
      if (this.checkMoney(this.afterRegular.after_salary_job_allowance)) {
        this.$message.error("请填写正确的岗位津贴");
        return;
      }
      if (this.checkMoney(this.afterRegular.after_salary_award)) {
        this.$message.error("请填写正确的奖金");
        return;
      }
      if (this.checkMoney(this.afterRegular.after_salary_meal)) {
        this.$message.error("请填写正确的餐补");
        return;
      }
      if (this.checkMoney(this.afterRegular.after_salary_phone)) {
        this.$message.error("请填写正确的话费补贴");
        return;
      }
      let params = {
        id: this.parentData.id,
        regularDate: this.regularDate + '-01',
        fileData: this.fileData,
        fileList: this.fileList,
        employeeRegular: this.employeeRegular,
        afterRegular: this.afterRegular,
        beforeRegular: this.beforeRegular,
        employeeName: this.employee_name,
        employeeNo: this.employee_no,
        remark: this.remark,
        file_id: this.file_id
      }
      await this.$http("employeeRegularProcessService.saveEmployeeRegularInfo", params)
          .then(() => {
        this.$message.success("保存成功！");
        this.$fn.closeWindow();
        this.$fn.search();
      })
    },
    async getData() {
      let params = {
        id: this.parentData.id
      }
      // console.log("this.beforeRegular",this.beforeRegular)
      if (params.id !== undefined) {
        let data = await this.$http("employeeRegularProcessService.getById", params);
        this.employeeRegular.employeeName = data.employee_name
        this.employeeRegular.employeeNo = data.employee_no
        this.employeeRegular.positionId = data.position_id
        this.employeeRegular.departmentId = data.department_ids
        this.employeeRegular.employeeType = data.employee_type
        this.employeeRegular.entryDate = data.entry_date
        this.employeeRegular.probationEndDate = data.probation_end_date
        this.beforeRegular.salary_basic = data.salary_basic
        this.beforeRegular.salary_merit = data.salary_merit
        this.beforeRegular.salary_job_allowance = data.salary_job_allowance
        this.beforeRegular.salary_award = data.salary_award
        this.beforeRegular.salary_meal = data.salary_meal
        this.beforeRegular.salary_phone = data.salary_phone
        this.regularDate = data.probation_end_date
      }
    },


    startPage(item, itemData) {
      let windowObj = {}
      windowObj.icon = "system/view";
      windowObj.component = "prc/PrcPdf";
      windowObj.name = item.original_name.substring(0, item.original_name.length - 4);
      windowObj.parentData = {sys_file: item, itemData: itemData};
      windowObj.height = 1000 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 1450 || this.$store.getters['core/getGlobalWindowWidth']

      this.$store.dispatch('core/openWindow', windowObj)
    },
//下载文件
    downloadPage(item) {
      let url = item?.url;
      if (!url) {
        return
      }
      let name = item.name

      const a = document.createElement('a')

      if (!url.startsWith('http')) {
        url = window.location.protocol + "//" + window.location.host + (url.startsWith('/') ? '' : '/') + url;
      }
      // 这里是将url转成blob地址，
      fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        a.href = URL.createObjectURL(blob)
        a.download = name || '' // 下载文件的名字
        document.body.appendChild(a)
        a.click()

        //在资源下载完成后 清除 占用的缓存资源
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      })
    },
    handleUploadSuccess(response, file) {
      this.fileList.push({
        uid: file.uid,
        name: file.name,
        url: URL.createObjectURL(file.raw)
      });
      this.$message.success(`${file.name} 上传成功`);
    },
    previewFile(file) {
      this.$message.info(`预览文件：${file.name}`);
      // 这里可以实现打开文件预览的逻辑
    },
    handleUploadError(err, file) {
      this.$message.error(`${file.name} 上传失败`);
    },
    beforeUpload(file) {
      const isPDF = file.type === 'application/pdf';
      if (!isPDF) {
        this.$message.error('只能上传 PDF 文件');
      }
      return isPDF;  // 如果不是 PDF 文件，返回 false 阻止上传
    },

    deleteFile(file) {
      this.fileList = this.fileList.filter(f => f.uid !== file.uid);
      this.$message.success(`${file.name} 已删除`);
    },
    async getDept() {
      this.departmentList = await this.$http('sysUserDepartmentService.getDepartmentData');
      console.log(this.departmentList + "部门列表")
    },
    async getOptions() {
      await this.$http("employeeHRService.getAll").then(res =>{
        this.positionList = res.employee_position
        this.empTypeList = res.employee_type
        this.salaryTypeList = res.salary_type_options
      })
    },
  },
  async created() {
    await this.getOptions();
    await this.getDept();
    await this.getData();// 在组件创建时获取数据
  },
}
</script>

<style scoped lang="less">

.bordered-container {
  border: 0.5px solid lightgrey !important;
  padding: 10px 60px 10px 0;
  width: 97%;
  margin: 10px;
}

.app {
  margin: 20px;
}

.upload-button {
  display: inline-block;
  margin-left: 10px;
}

.file-actions {
  text-align: right;
}
</style>
